import piigLogo from '../../assets/piig-logo.png';

const DEFAULT_BRAND_NAME = 'PILOT INNOVATION GROUP CO.,LTD.';

/**
 * Full-width vendor-attribution banner above the sidebar+content row — logo
 * + company name, "who built this." Ships with a real default (committed to
 * git) but stays overridable via VITE_BRAND_NAME / VITE_BRAND_LOGO_URL (see
 * .env.example).
 */
export function BrandBanner() {
  const name = (import.meta.env.VITE_BRAND_NAME as string | undefined) || DEFAULT_BRAND_NAME;
  const logoUrl = (import.meta.env.VITE_BRAND_LOGO_URL as string | undefined) || piigLogo;

  return (
    <div className="flex shrink-0 items-center gap-2 border-b border-border bg-text-primary px-6 py-1.5 md:px-8">
      <img src={logoUrl} alt={name} className="h-7 w-7 shrink-0 object-contain" />
      <span className="truncate text-sm font-bold tracking-wide text-surface md:text-base">{name}</span>
    </div>
  );
}
